import * as i0 from '@angular/core';
import { input, computed, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { COMPONENT_STATE, GhostStateFragmentDirective } from '@futura/futura-ui/ghost';
import { getTranslateModel } from '@futura/futura-ui/core';
import { NgOptimizedImage, NgClass } from '@angular/common';
function IconTitleComponent_Conditional_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
}
function IconTitleComponent_Conditional_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
}
function IconTitleComponent_Conditional_0_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
}
function IconTitleComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, IconTitleComponent_Conditional_0_span_1_Template, 1, 0, "span", 2)(2, IconTitleComponent_Conditional_0_span_2_Template, 1, 0, "span", 3)(3, IconTitleComponent_Conditional_0_span_3_Template, 1, 0, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("futGhostStateFragment", ctx_r0.state())("futGhostStateFragmentText", "ICON")("futGhostStateFragmentParagraph", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("futGhostStateFragment", ctx_r0.state())("futGhostStateFragmentTextMinChar", 10)("futGhostStateFragmentTextMaxChar", 15)("futGhostStateFragmentParagraph", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("futGhostStateFragment", ctx_r0.state())("futGhostStateFragmentTextMinChar", 150)("futGhostStateFragmentTextMaxChar", 150)("futGhostStateFragmentParagraph", true);
  }
}
function IconTitleComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 7);
    i0.ɵɵtext(2, "Loading...");
    i0.ɵɵelementEnd()();
  }
}
function IconTitleComponent_Conditional_1_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngSrc", ctx);
  }
}
function IconTitleComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IconTitleComponent_Conditional_1_Conditional_2_Conditional_0_Template, 1, 1, "img", 8);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_2_0 = ctx_r0.image()) ? 0 : -1, tmp_2_0);
  }
}
function IconTitleComponent_Conditional_1_Conditional_3_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const translate_r2 = ctx.$implicit;
    const title_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", translate_r2(title_r3.text, title_r3.translateArgs), " ");
  }
}
function IconTitleComponent_Conditional_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IconTitleComponent_Conditional_1_Conditional_3_Conditional_1_ng_container_0_Template, 2, 1, "ng-container", 9);
  }
  if (rf & 2) {
    const title_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translocoScope", title_r3.scope || "");
  }
}
function IconTitleComponent_Conditional_1_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const title_r3 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", title_r3.text, " ");
  }
}
function IconTitleComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 5);
    i0.ɵɵtemplate(1, IconTitleComponent_Conditional_1_Conditional_3_Conditional_1_Template, 1, 1, "ng-container")(2, IconTitleComponent_Conditional_1_Conditional_3_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.titleClass());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx.translate ? 1 : 2);
  }
}
function IconTitleComponent_Conditional_1_Conditional_4_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const translate_r4 = ctx.$implicit;
    const subtitle_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", translate_r4(subtitle_r5.text, subtitle_r5.translateArgs), " ");
  }
}
function IconTitleComponent_Conditional_1_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, IconTitleComponent_Conditional_1_Conditional_4_Conditional_1_ng_container_0_Template, 2, 1, "ng-container", 9);
  }
  if (rf & 2) {
    const subtitle_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translocoScope", subtitle_r5.scope || "");
  }
}
function IconTitleComponent_Conditional_1_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const subtitle_r5 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", subtitle_r5.text, " ");
  }
}
function IconTitleComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtemplate(1, IconTitleComponent_Conditional_1_Conditional_4_Conditional_1_Template, 1, 1, "ng-container")(2, IconTitleComponent_Conditional_1_Conditional_4_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.subtitleClass());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx.translate ? 1 : 2);
  }
}
function IconTitleComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, IconTitleComponent_Conditional_1_Conditional_1_Template, 3, 0, "div", 4)(2, IconTitleComponent_Conditional_1_Conditional_2_Template, 1, 1)(3, IconTitleComponent_Conditional_1_Conditional_3_Template, 3, 2, "h1", 5)(4, IconTitleComponent_Conditional_1_Conditional_4_Template, 3, 2, "p", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showSpinner() ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_2_0 = ctx_r0.translatedTitle()) ? 3 : -1, tmp_2_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_3_0 = ctx_r0.translatedSubtitle()) ? 4 : -1, tmp_3_0);
  }
}
let IconTitleComponent = /*#__PURE__*/(() => {
  class IconTitleComponent {
    constructor() {
      this.state = input(COMPONENT_STATE.LOADING);
      this.showSpinner = input();
      this.image = input.required();
      this.iconTitle = input.required();
      this.subtitle = input();
      this.titleClass = input('');
      this.subtitleClass = input('');
      this.translatedTitle = computed(() => getTranslateModel(this.iconTitle()));
      this.translatedSubtitle = computed(() => getTranslateModel(this.subtitle()));
    }
    static {
      this.ɵfac = function IconTitleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconTitleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IconTitleComponent,
        selectors: [["fut-icon-title"]],
        inputs: {
          state: [1, "state"],
          showSpinner: [1, "showSpinner"],
          image: [1, "image"],
          iconTitle: [1, "iconTitle"],
          subtitle: [1, "subtitle"],
          titleClass: [1, "titleClass"],
          subtitleClass: [1, "subtitleClass"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "d-flex", "flex-column", "align-items-center"], [1, "d-flex", "flex-column", "fut-gap-4"], [4, "futGhostStateFragment", "futGhostStateFragmentText", "futGhostStateFragmentParagraph"], [4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar", "futGhostStateFragmentParagraph"], ["role", "status", 1, "spinner-border", 2, "width", "3rem", "height", "3rem"], [1, "fut-h1", "fut-m-0", "text-center", 3, "ngClass"], [1, "fut-m-0", "text-center", "fut-text-light", 3, "ngClass"], [1, "sr-only"], ["alt", "title-icon", "width", "40", "height", "40", 1, "align-self-center", "fut-m-0", 3, "ngSrc"], [4, "transloco", "translocoScope"]],
        template: function IconTitleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, IconTitleComponent_Conditional_0_Template, 4, 11, "div", 0)(1, IconTitleComponent_Conditional_1_Template, 5, 3, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.state() !== "NONE" ? 0 : 1);
          }
        },
        dependencies: [TranslocoDirective, GhostStateFragmentDirective, NgOptimizedImage, NgClass]
      });
    }
  }
  return IconTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IconTitleComponent };
